import React, { useEffect, useRef, useState } from 'react'

import { Input } from '../input'

const TimeInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>((props, ref) => {
    const [value, setValue] = useState((props.value as string) || '')
    const inputRef = useRef<HTMLInputElement>(null)
    // Change state if incoming prop value changes
    useEffect(() => setValue((props.value as string) || ''), [props.value])

    React.useImperativeHandle(ref, () => inputRef.current!)

    const formatTime = (input: string) => {
        const digits = input.replace(/\D/g, '').slice(0, 4)
        if (digits.length <= 2) return digits
        return `${digits.slice(0, 2)}:${digits.slice(2)}`
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const input = e.target
        const newValue = input.value.replace(':', '')
        const formatted = formatTime(newValue)
        const cursorPosition = input.selectionStart || 0

        let newCursorPosition = cursorPosition
        if (formatted.length > value.length) {
            newCursorPosition += formatted.length - value.length
        } else if (cursorPosition > 2 && newValue.length <= 2) {
            newCursorPosition--
        }

        setValue(formatted)
        const event = {
            ...e,
            target: {
                ...e.target,
                value: formatted,
            },
        }
        props.onChange?.(event)

        requestAnimationFrame(() => {
            input.setSelectionRange(newCursorPosition, newCursorPosition)
        })
    }

    return <Input placeholder="HH:MM" {...props} value={value} onChange={handleChange} ref={inputRef} />
})

TimeInput.displayName = 'TimeInput'

export default TimeInput
